import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "meterox_cookie_consent";

export default function CookieConsent() {
  const { t } = useApp();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, ts: Date.now() }));
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4"
    >
      <div className="mx-auto flex max-w-[1100px] flex-col gap-3 border border-border bg-card p-4 shadow-2xl sm:flex-row sm:items-center sm:gap-5">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center bg-primary text-primary-foreground">
            <Cookie className="h-5 w-5" strokeWidth={2.2} />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-bold">{t("cookieTitle")}</div>
            <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">{t("cookieText")}</p>
          </div>
        </div>
        <div className="flex shrink-0 gap-2 sm:ml-auto">
          <Button
            data-testid="cookie-reject"
            variant="outline"
            onClick={() => decide("necessary")}
            className="flex-1 rounded-none border-border text-xs sm:flex-none"
          >
            {t("cookieReject")}
          </Button>
          <Button
            data-testid="cookie-accept"
            onClick={() => decide("all")}
            className="flex-1 rounded-none bg-primary text-xs text-primary-foreground hover:opacity-90 sm:flex-none"
          >
            {t("cookieAccept")}
          </Button>
        </div>
      </div>
    </div>
  );
}
